import { useState, Fragment, useCallback, useContext } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { HiMenuAlt4 } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import Flags from "country-flag-icons/react/3x2";

import { Context } from "src/components/LanguageContext";
import logo from "src/assets/images/Logo.png";

const navData = [
  {
    name: "menu.home",
    href: "/",
    type: "internal",
  },
  {
    name: "menu.service",
    href: "service",
    type: "internal",
  },
  {
    name: "menu.catalog",
    href: "product",
    type: "internal",
  },
  {
    name: "menu.about",
    href: "about-us",
    type: "internal",
  },
  {
    name: "menu.customer",
    href: "our-customer",
    type: "internal",
  },
  {
    name: "menu.contact",
    href: "contact",
    type: "internal",
  }
];

const CountEstimate = ({ className = "", href, count, isNew }) => {
  if (count <= 0 || href !== "estimate") return null;
  return (
    <Fragment>
      {isNew && (<span className={`px-0.5 py-0.5 text-xs font-light font-prompt text-center absolute rounded-full bg-danger w-5 h-5 animate-ping ${className}`}></span>)}
      <span className={`px-0.5 py-0.5 flex justify-center items-center text-xs font-light font-prompt text-center absolute rounded-full border-[1px] border-white-2 bg-danger w-5 h-5 ${className}`}>{count}</span>
    </Fragment>
  );
};

const Navbar = () => {
    const context = useContext(Context);
    const intl = useIntl();

  const [toggleMenu, setToggleMenu] = useState(false);

  const handelOpenMenu = useCallback(() => {
    setToggleMenu(true);
  }, []);
  const handelCloseMenu = useCallback(() => {
    setToggleMenu(false);
  }, []);

  return (
    <nav className="w-full font-orbitron flex justify-between items-center border-b-2 border-black bg-bgPrimary lg:mx-auto lg:px-8 py-2">
      <div className="flex justify-center items-center py-5">
        <img src={logo} alt="logo" className="w-20" />
        <ul className="hidden md:flex p-0">
          {navData.map((item, key) => {
            return (
              <li id={`menu-${intl.formatMessage({ id: item.name})}`} key={key}>
                {(item.type === "external") ? (
                  <a className="flex text-P600 text-center font-semibold text-xl rounded-full relative cursor-pointer hover:bg-bgSecondary px-2 py-1 mx-3 lg:mx-8 tracking-wider" href={item.href} target="_blank" rel="noreferrer">
                    {intl.formatMessage({ id: item.name})}
                  </a>
                ) : (
                  <Link
                    to={item.href}
                    className="flex text-P600 text-center font-semibold text-xl rounded-full relative cursor-pointer hover:bg-bgSecondary px-2 py-1 mx-3 lg:mx-8 tracking-wider"
                  >
                    {intl.formatMessage({ id: item.name})}
                    <CountEstimate href={item.href} className="-top-1 -right-1" />
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="hidden md:flex">
      
        <div>
            <select className="form-select appearance-none block w-full px-3 py-1.5 text-base font-normal text-black-2  bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" value = {context.locale} onChange={context.selectLanguage}>
                <option value= 'en'>English</option>
                <option value= 'th'> <Flags.TH /> Thai</option>
            </select>
        </div>
      </div>
      <div className="flex relative px-2 text-P600">
        {toggleMenu ? (
          <AiOutlineClose
            fontSize={28}
            className="md:hidden cursor-pointer"
            onClick={() => handelCloseMenu()}
          />
        ) : (
          <HiMenuAlt4
            fontSize={28}
            className="md:hidden cursor-pointer"
            onClick={() => handelOpenMenu()}
          />
        )}
        {toggleMenu && (
          <ul
            className="flex flex-col justify-start items-end fixed text-end top-0 -right-2 p-3 w-80 h-screen md:hidden
              list-none rounded-md shadow-2xl font-semibold bg-bgPrimary z-50"
          >
            <li className="text-xl w-full my-2">
              <AiOutlineClose onClick={() => handelCloseMenu()} />
            </li>
            {navData.map((item, key) => (
              <li key={key} className="mx-6 cursor-pointer my-2 text-lg tracking-wider">
                {(item.type === "external") ? (
                  <a className="relative" href={item.href} target="_blank" rel="noreferrer">
                    {intl.formatMessage({ id: item.name})}
                  </a>
                ) : (
                  <Link to={item.href} className="relative">
                    {intl.formatMessage({ id: item.name})}
                    <CountEstimate href={item.href} className="-top-3 -right-2" />
                  </Link>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
